export default __webpack_public_path__ + "images/c79f45fe3118b847aa4b0e46b615d103.svg";